import { NavLink, Outlet } from "react-router-dom";
import { Shield, LayoutDashboard, BookCopy, FolderTree, FileUp, LogOut, ExternalLink, MessageSquare } from "lucide-react";
import { useAuth } from "../../context/AuthContext";

export default function AdminLayout() {
  const { user, logout } = useAuth();

  const item = ({ isActive }) =>
    `flex items-center gap-3 px-3 py-2 text-sm rounded-xl transition-colors ${
      isActive
        ? "bg-gcgreen/20 text-gcgold border border-gcgreen/30"
        : "text-slate-400 hover:bg-white/5 hover:text-white"
    }`;

  return (
    <div className="min-h-screen flex bg-ink">
      <aside className="w-60 bg-ink-900 flex-shrink-0 hidden md:flex flex-col border-r border-white/5" data-testid="admin-sidebar">
        <div className="p-5 border-b border-white/5">
          <div className="flex items-center gap-2 text-white">
            <div className="h-9 w-9 rounded-xl bg-white/5 border border-white/10 flex items-center justify-center">
              <Shield className="h-5 w-5 text-gcgold" />
            </div>
            <div>
              <div className="font-display font-extrabold text-sm tracking-tight">Panel admin</div>
              <div className="text-[10px] uppercase tracking-[0.22em] text-gcgold font-bold font-mono">Gestión</div>
            </div>
          </div>
        </div>

        <nav className="p-3 space-y-1 flex-1">
          <NavLink to="/admin" end className={item} data-testid="admin-nav-overview">
            <LayoutDashboard className="h-4 w-4" /> Resumen
          </NavLink>
          <NavLink to="/admin/questions" className={item} data-testid="admin-nav-questions">
            <BookCopy className="h-4 w-4" /> Preguntas
          </NavLink>
          <NavLink to="/admin/categories" className={item} data-testid="admin-nav-categories">
            <FolderTree className="h-4 w-4" /> Categorías y temas
          </NavLink>
          <NavLink to="/admin/import" className={item} data-testid="admin-nav-import">
            <FileUp className="h-4 w-4" /> Importar
          </NavLink>
          <NavLink to="/admin/contactos" className={item} data-testid="admin-nav-contacts">
            <MessageSquare className="h-4 w-4" /> Contactos
          </NavLink>
        </nav>

        <div className="p-3 border-t border-white/10">
          <NavLink to="/dashboard" className="flex items-center gap-2 px-3 py-2 text-xs text-slate-300 hover:text-white">
            <ExternalLink className="h-3.5 w-3.5" /> Volver a la app
          </NavLink>
          <div className="mt-2 px-3 py-2 text-xs text-slate-400">
            <div className="text-slate-300 truncate">{user?.name}</div>
            <div className="truncate">{user?.email}</div>
          </div>
          <button
            onClick={logout}
            className="flex items-center gap-2 px-3 py-2 w-full text-xs text-red-300 hover:text-red-100 hover:bg-red-900/30 rounded-sm"
            data-testid="admin-logout"
          >
            <LogOut className="h-3.5 w-3.5" /> Salir
          </button>
        </div>
      </aside>

      <main className="flex-1 overflow-auto">
        <Outlet />
      </main>
    </div>
  );
}
